import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import CompactLayout from 'src/layouts/compact';

// ----------------------------------------------------------------------

const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const MaintenancePage = lazy(() => import('src/pages/maintenance'));
const StripeSuccessPage = lazy(() => import('src/pages/stripe-success'));
const StripeCancelPage = lazy(() => import('src/pages/stripe-cancel'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  // Public, no-header routes for Stripe callbacks
  {
    element: <Outlet />,
    children: [
      { path: 'payment/success/:group_id', element: <StripeSuccessPage /> },
      { path: 'payment/cancel/:group_id', element: <StripeCancelPage /> },
    ],
  },
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
];
